import type { CSSProperties, ReactNode } from 'react';

/**
 * Present to assistive technology, absent on screen.
 *
 * The clip-rect approach rather than `display: none` or `visibility: hidden`,
 * both of which remove the content from the accessibility tree entirely.
 */
const style: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
};

export function VisuallyHidden({
  children,
  live,
  name,
}: {
  children: ReactNode;
  /** Set to announce changes to the content as they happen. */
  live?: 'polite' | 'assertive';
  /** Identifies this region; several can be live at once on one screen. */
  name?: string;
}) {
  return (
    <div style={style} data-live={name} aria-live={live} aria-atomic={live ? true : undefined}>
      {children}
    </div>
  );
}
